/*
 * @Describe:
 * @Author: wangalong
 * @LastEditTime: 2022-10-28 12:10:23
 */
import Vue from 'vue'
import store from '@/store'
import { isKbApp } from '@/hooks/use-env'
import { jumpToRenewalToken } from '@/utils/kb-bridge'
import { navigateToQQAppStore } from '@/utils/tools'

var tokenLock = false

export function localUserInfo(_self) {
    let userInfo = _self.$store.getters.getUserInfo
    if (userInfo.needJsToGetUserInfo) {
        _self.$bridge.callHandler(
            'OpenActRequest',
            {
                type: 31,
                data: {
                    requireLogin: false,
                },
            },
            function (response) {
                try {
                    let res = typeof response === 'string' ? JSON.parse(response) : response
                    if (res.data.userId != null) {
                        _self.$store.dispatch('updateUserInfo', res.data)
                        _self.$store.dispatch('updateUserJsUserInfo', false)
                    }
                } catch (error) {}
            },
        )
    }
}

export function loginCheck(_self) {
    if (!isKbApp) {
        navigateToQQAppStore()
    }
    let userInfo = _self.$store.getters.getUserInfo
    if (!userInfo.needJsToGetUserInfo) {
        return new Promise((resolve) => {
            resolve(userInfo)
        })
    }
    return new Promise((resolve, reject) => {
        try {
            _self.$bridge.callHandler(
                'OpenActRequest',
                {
                    type: 31,
                    data: {
                        requireLogin: true,
                    },
                },
                function (response) {
                    let res = JSON.parse(response)
                    if (res.data.userId != null) {
                        _self.$store.dispatch('updateUserInfo', res.data)
                        _self.$store.dispatch('updateUserJsUserInfo', false)
                        resolve(res.data)
                    } else {
                        reject(res.data)
                    }
                },
            )
        } catch (error) {
            reject({ error: error })
        }
    })
}

export function autoRenewalToken() {
    if (tokenLock) {
        return false
    }
    tokenLock = true
    window.vue.$store.dispatch('global/updateOnAutoRenewalToken', true)
    jumpToRenewalToken(window.vue, {}, function (res) {
        tokenLock = false
        var userInfo = JSON.parse(res).data
        window.vue.$store.dispatch('updateUserInfo', userInfo)
        window.vue.$store.dispatch('updateUserJsUserInfo', false)
        window.vue.$store.dispatch('global/updateOnAutoRenewalToken', false)
    })
}

/** 静默登录 */
export function silentLogin() {
    return new Promise((resolve, reject) => {
        Vue.prototype.$bridge.callHandler(
            'OpenActRequest',
            {
                type: 31,
                data: {
                    requireLogin: false,
                },
            },
            function (response) {
                const userInfo = JSON.parse(response).data
                if (!userInfo) {
                    return reject(null)
                }

                store.dispatch('updateUserInfo', userInfo)
                return resolve(userInfo)
            },
        )
    })
}
